import { defaultLocalisation } from './localisationDefaults';
import Localisation from '../interfaces/localisation'

import { fetchLocalisation } from '../Redux/slices/localisationSlice';

interface LanguageDictionary {
    [key: string]: string
}

function getStore() {
    return require("../Redux/store").store;
}

const localisation = {

    languageDictionary: {...defaultLocalisation} as LanguageDictionary,
    language: window.navigator.language,

    setup(){

        this.language = window.navigator.language;
        this.languageDictionary = {...defaultLocalisation};

        return this.setUpLanguageDictionary();
    },

    setUpLanguageDictionary() {

        const {status, language} = getStore().getState().localisation;

        if (status === 'idle' || (status === 'succeeded' && language !== navigator.language)) {
            getStore().dispatch(fetchLocalisation());
        }

        return;
    },

    getLocalString(key: Localisation, replacements?: string []): string {
        /**
         * Add keys and values to localisationDefaults.ts for fallbacks
        */

        const { languageDictionary } = getStore().getState().localisation;
        
        let string = languageDictionary[key]
        
        if (string && replacements?.length) {
            string = this.interpolate(string, replacements)
        }

        if (string === ""){
            console.error("Missing localisation string:" + key)
        }

        if (string && string.includes('[strong]')) {
            string = this.emphasis(string, 'strong', 'strong');
            
        }

        if (string && string.includes('[underline]')) {
            string = this.emphasis(string, 'underline', 'u');
            
        }

        if(string && string.includes('[break][/break]')) {
            string = string.split('[break][/break]').join('<br />');
        }
        
        return string;
    },

    interpolate(string: string, replacements: string[]) {
        for (const [idx, value] of Array.from(replacements.entries())) {
            const ref = `{${idx}}`
            string = string.split(ref).join(value);
        }
        return string
    },

    emphasis(string: string, placeholder: string, replacementTag: string): string {
        const openingTag = new RegExp(`\\[${placeholder}]`);
        const closingTag =  new RegExp(`\\[/${placeholder}]`);
        return string
            .split(openingTag).join( "<" + replacementTag + ">")
            .split(closingTag).join("</" + replacementTag + ">");
    },

    refreshLocalistaion() {
        getStore() .dispatch(fetchLocalisation());
    }

}

export default localisation